import React, { useContext } from "react";
import Home from "./Home";
import Login from "./Login";
import { AppContext } from "./Store";

export default function SecuredRoute() {
  const { authData } = useContext(AppContext);
  return <>{authData?.token && authData?.imePrezime ? <Home /> : <Login />}</>;
}
